import { IArea } from 'models';
import { client } from 'shared';

export function getRegions(): Promise<IArea[]> {
    return client('api/regions/');
}
